module.exports = __webpack_public_path__ + "static/flags/IE-fa6fd0137cb55b2bb4644fb2263bfa81.gif";